import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { InputChips } from '@gem/ui-kit';

import { Avatar, AvatarTypes } from 'APP/components/Avatar/Avatar';

import { IFormUser } from '../Form.types';
import styles from './ChipsList.styles.m.css';

interface IChipsProps {
  value: string[];
  selectedParticipants: IFormUser[];
  initiatorEmail: string;
  removeChip: (id: string) => void;
}

export const ChipsList: FC<IChipsProps> = observer((props) => {
  const { value, selectedParticipants, initiatorEmail, removeChip } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <InputChips
        chips={value.map((email) => {
          const user = selectedParticipants.find(
            (selectedParticipant) => selectedParticipant.email === email
          );
          const isInitiator = initiatorEmail === email;
          const badge = isInitiator ? `(${t('calendar_event_initiator')})` : '';

          return {
            id: user?.id || email || '',
            children: (
              <div className={styles.containerChipContent}>
                <Avatar
                  type={AvatarTypes.Round_05}
                  title={user?.displayName || ''}
                  url={user?.avatarUrl || ''}
                  backgroundColorIndex={user?.avatarColorIndex || '1'}
                />
                <div className={styles.title}>{user?.displayName || email}</div>
                {badge && <div className={styles.badge}>{badge}</div>}
              </div>
            ),
            onRemove: isInitiator ? undefined : removeChip,
            className: styles.containerChip,
          };
        })}
      />
    </div>
  );
});
